export default class Inventory {
	static SLOT_NOTHING = 0;
	static SLOT_HELMET = 1;
	static SLOT_RIGHT_HAND = 2;
	static SLOT_LEFT_HAND = 3;
	static SLOT_BODY = 4;
	static SLOT_SHOES = 5;
	static SLOT_HORSE = 6;
	static SLOT_BAG = 7;
	
	static TYPE_HELMET_0_0 = 1; //свой
	static TYPE_HELMET_0_1 = 2; //свой
	static TYPE_HELMET_0_2 = 3; //свой
	static TYPE_HELMET_1_0 = 4;
	static TYPE_HELMET_1_1 = 5; //свой
	static TYPE_HELMET_1_2 = 6; //свой
	static TYPE_HELMET_2_0 = 7; //свой
	static TYPE_HELMET_2_1 = 8; //свой
	static TYPE_HELMET_2_2 = 9; //свой
	static TYPE_HELMET_3_0 = 10;
	static TYPE_HELMET_3_1 = 11; //свой
	static TYPE_HELMET_3_2 = 12; //свой
	static TYPE_HELMET_4_0 = 13;
	static TYPE_HELMET_4_1 = 14; //свой
	static TYPE_HELMET_4_2 = 15; //свой
	
	static TYPE_SWORD_0_0 = null;
	static TYPE_SWORD_0_1 = null;
	static TYPE_SWORD_0_2 = null;
	static TYPE_SWORD_1_0 = null;
	static TYPE_SWORD_1_1 = null;
	static TYPE_SWORD_1_2 = null;
	static TYPE_SWORD_2_0 = null;
	static TYPE_SWORD_2_1 = null;
	static TYPE_SWORD_2_2 = null;
	static TYPE_SWORD_3_0 = null;
	static TYPE_SWORD_3_1 = null;
	static TYPE_SWORD_3_2 = null;
	
	static TYPE_SPEAR_0_0 = 31;
	static TYPE_SPEAR_0_1 = 32; //свой
	static TYPE_SPEAR_0_2 = 33; //свой
	static TYPE_SWORD_4_0 = 34; //свой
	static TYPE_SWORD_4_1 = 35;
	static TYPE_SWORD_4_2 = 36; //свой
	static TYPE_BOW_0_0 = 37;
	static TYPE_BOW_0_1 = 38; //свой
	static TYPE_BOW_0_2 = 39; //свой
	
	static TYPE_SPEAR_1_0 = 43;
	static TYPE_SPEAR_1_1 = 44; //свой
	static TYPE_SPEAR_1_2 = 45; //свой
	static TYPE_SPEAR_2_0 = 46; //свой
	static TYPE_SPEAR_2_1 = 47; //свой
	static TYPE_SPEAR_2_2 = 48; //свой
	
	static TYPE_SWORD_5_0 = null;
	static TYPE_SWORD_5_1 = null;
	static TYPE_SWORD_5_2 = null;
	
	static TYPE_STAFF_0_0 = null;
	static TYPE_STAFF_0_1 = null;
	static TYPE_STAFF_0_2 = null;
	
	static TYPE_SHIELD_0_0 = null;
	static TYPE_SHIELD_0_1 = null;
	static TYPE_SHIELD_0_2 = null;
	
	static TYPE_SACK_0_0 = null;
	static TYPE_SACK_0_1 = null;
	static TYPE_SACK_0_2 = null;
	
	static TYPE_MAP_0_0 = 61;
	static TYPE_MAP_0_1 = 62; //свой
	static TYPE_MAP_0_2 = 63; //свой
	
	static TYPE_SHIRT_0_0 = 82;
	static TYPE_SHIRT_0_1 = 83; //свой
	static TYPE_SHIRT_0_2 = 84; //свой
	static TYPE_SHIRT_1_0 = 85; //свой
	static TYPE_SHIRT_1_1 = 86; //свой
	static TYPE_SHIRT_1_2 = 87; //свой
	static TYPE_SHIRT_2_0 = 88; //свой
	static TYPE_SHIRT_2_1 = 89; //свой
	static TYPE_SHIRT_2_2 = 90; //свой
	static TYPE_SHIRT_3_0 = 91; //свой
	static TYPE_SHIRT_3_1 = 92; //свой
	static TYPE_SHIRT_3_2 = 93; //свой
	static TYPE_SHOES_0_0 = 94;
	static TYPE_SHOES_0_1 = 95; //свой
	static TYPE_SHOES_0_2 = 96; //свой
	static TYPE_SHOES_1_0 = 97; //свой
	static TYPE_SHOES_1_1 = 98; //свой
	static TYPE_SHOES_1_2 = 99; //свой
	static TYPE_SHOES_2_0 = 100; //свой
	static TYPE_SHOES_2_1 = 101; //свой
	static TYPE_SHOES_2_2 = 102; //свой
	static TYPE_HORSE_1_0 = 103;
	static TYPE_HORSE_1_1 = 104; //свой
	static TYPE_HORSE_1_2 = 105; //свой
	static TYPE_HORSE_2_0 = 106; //свой
	static TYPE_HORSE_2_1 = 107; //свой
	static TYPE_HORSE_2_2 = 108; //свой
	static TYPE_HORSE_0_0 = 109; //свой
	static TYPE_HORSE_0_1 = 110; //свой
	static TYPE_HORSE_0_2 = 111; //свой
	static TYPE_OINTMENT = 112;
	static TYPE_SCROLL = 113;
	
	static TYPE_BOOK = 115;
	static TYPE_ARTWORK = 116;
	static TYPE_SMALL_BANDAGE = 117;
	static TYPE_BANDAGE = null;
	
	static TYPE_TREASURES = 120;
	
	static TYPE_SHOES_3_0 = 121;
	static TYPE_SHOES_3_1 = 122; //свой
	static TYPE_SHOES_3_2 = 123; //свой
	static TYPE_HEALING_POTION = 124;
	
	static TYPE_UPGRADE_HELMET = null;
	static TYPE_UPGRADE_SHOES = null;
	static TYPE_UPGRADE_WEAPON = 126;
	static TYPE_UPGRADE_ACCESSORY = null;
	static TYPE_UPGRADE_ARMOR = null;
	static TYPE_WATER_BUCKET = null;
	
	static TYPE_RESOURCE_BONUS_3 = 130;
	static TYPE_RESOURCE_BONUS_4 = 131;
	static TYPE_RESOURCE_BONUS_5 = 132;
	static TYPE_CROP_BONUS_3 = 133;
	static TYPE_CROP_BONUS_4 = 134;
	static TYPE_CROP_BONUS_5 = 135;
	static TYPE_ADVENTURE_POINT = 136;
	
	static TYPE_FINISH_IMMEDIATELY = 138;
	static TYPE_NPC_TRADER = 139;
	static TYPE_INSTANT_DELIVERY = 140;
	
	static TYPE_FIREWORKS = null;
	static TYPE_SUPER_FIREWORKS = null;
	static TYPE_BANDAGE_25 = null;
	static TYPE_BANDAGE_25_UPGRADED = null;
	static TYPE_BANDAGE_33 = null;
	static TYPE_BANDAGE_33_UPGRADED = null;
	static TYPE_CAGES = null;
	
	static TYPE_RESOURCES_WOOD_S = null;
	static TYPE_RESOURCES_WOOD_M = null;
	static TYPE_RESOURCES_WOOD_L = null;
	static TYPE_RESOURCES_IRON_S = null;
	static TYPE_RESOURCES_IRON_M = null;
	static TYPE_RESOURCES_IRON_L = null;
	static TYPE_RESOURCES_CROP_S = null;
	static TYPE_RESOURCES_CROP_M = null;
	static TYPE_RESOURCES_CROP_L = null;
	static TYPE_RESOURCES_CLAY_S = null;
	static TYPE_RESOURCES_CLAY_M = null;
	static TYPE_RESOURCES_CLAY_L = null;
	static TYPE_LANCE_0_0 = null;
	static TYPE_LANCE_0_1 = null;
	static TYPE_LANCE_0_2 = null;
	static TYPE_HORN_0_0 = null;
	static TYPE_HORN_0_1 = null;
	static TYPE_HORN_0_2 = null;
	static TYPE_HAMMER_0_0 = null;
	static TYPE_HAMMER_0_1 = null;
	static TYPE_HAMMER_0_2 = null;
	static TYPE_FLAG_0_0 = null;
	static TYPE_FLAG_0_1 = null;
	static TYPE_FLAG_0_2 = null;
	static TYPE_FLAG_1_0 = null;
	static TYPE_FLAG_1_1 = null;
	static TYPE_FLAG_1_2 = null;
	static TYPE_CLUB_0_0 = null;
	static TYPE_CLUB_0_1 = null;
	static TYPE_CLUB_0_2 = null;
	static TYPE_AXE_0_0 = null;
	static TYPE_AXE_0_1 = null;
	static TYPE_AXE_0_2 = null;
	
	static TYPE_BUILDING_GROUND = null;
}